<script>
export default {
    props: {
        typr: {
            type: String,  // Assuming it's a string, adjust if needed
        },
    },
    computed: {
        collectionClass() {
            return this.typr === 'collection' ? 'nav-link active' : 'nav-link';
        },
        invoiceClass() {
            return this.typr === 'invoice' ? 'nav-link active' : 'nav-link';
        },
        creditNoteClass() {
            return this.typr === 'creditnote' ? 'nav-link active' : 'nav-link';
        },
        soaClass() {
            return this.typr === 'soa' ? 'nav-link active' : 'nav-link';
        },
        agingReportClass() {
            return this.typr === 'agingreport' ? 'nav-link active' : 'nav-link';
        },
        paymentClass() {
            return this.typr === 'payment' ? 'nav-link active' : 'nav-link';
        },
        NodClass() {
            return this.typr === 'nod' ? 'nav-link active' : 'nav-link';
        },
        mdmEnrolledClass() {
            return this.typr === 'mdmenrolled' ? 'nav-link active' : 'nav-link';
        },
        
    },
}
</script>

<template>
    <ul class="nav-tabs-wrapper">
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar'" :class="collectionClass">
            <i class="ri-information-line text-muted align-bottom me-1"></i>
            Collection Details
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/invoice'" :class="invoiceClass">
            <i class="ri-shopping-cart-2-line text-muted align-bottom me-1"></i>
            Monthly Statement
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/creditnote'" :class="creditNoteClass">
            <i class="ri-file-edit-line text-muted align-bottom me-1"></i>
            Credit Notes
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/soa'" :class="soaClass">
            <i class="ri-checkbox-multiple-line text-muted align-bottom me-1"></i>
            Statement of Account
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/agingreport'" :class="agingReportClass">
            <i class="ri-checkbox-multiple-line text-muted align-bottom me-1"></i>
            Aging Report
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/payment'" :class="paymentClass">
            <i class="ri-checkbox-multiple-line text-muted align-bottom me-1"></i>
            List Of Payment
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/nod'" :class="NodClass">
            <i class="ri-checkbox-multiple-line text-muted align-bottom me-1"></i>
            Manual Payment Creation
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/mdm-enrolled'" :class="mdmEnrolledClass">
            <i class="ri-device-line text-muted align-bottom me-1"></i>
            MDM Enrolled Device
        </router-link>
    </li>
    </ul>
</template>

<style scoped>
.nav-tabs-wrapper {
  display: flex;
  flex-wrap: nowrap;      /* prevent wrapping */
  overflow-x: auto;       /* allow horizontal scroll */
  -webkit-overflow-scrolling: touch; /* smooth scroll on mobile */
  white-space: nowrap;    /* keep text on one line */
  list-style: none;       /* remove default list bullets */
  padding: 0 0 8px 0;
  margin: 0;
}

.nav-tabs-wrapper .nav-item {
  flex: 0 0 auto; /* prevent shrinking */
}

.nav-tabs-wrapper .nav-link {
  color: #333;         /* default text color */
}

.nav-tabs-wrapper .nav-link.active {
  color: blue;      /* active color */
}
</style>